module Meevo.Plugins.Tippy {
    "use strict";

    export class LogSection extends Meevo.Components.CommonClasses.CommonSectionBase {
        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            protected contextParams: Meevo.ContextParamsService,
            identityService: Components.Common.IIdentityService = null,
            sectionSecurityKey?: string
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, sectionSecurityKey)
            this.isInteropContext = true;
        }

        selected() {
            super.selected();
            this.contextParams.addInteropParams({ id: 'interop:tippy', isInterop: true, targetRoute: `tippy/log` });
        }

    }
}
